import { render, staticRenderFns } from "./TimeSale.vue?vue&type=template&id=518ab34a&"
import script from "./TimeSale.vue?vue&type=script&lang=ts&"
export * from "./TimeSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports